import { render, staticRenderFns } from "./formato.vue?vue&type=template&id=67523202"
import script from "./formato.vue?vue&type=script&lang=js"
export * from "./formato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports